import { createApp } from 'vue';
import { VueFire, VueFireAuth } from 'vuefire';
import App from './App.vue';
import './style.scss';
import { firebaseApp } from './firebase';
import { router } from './core/routes';

import { OutsideClickDirective } from './core/directives/outsideClick.directive';
import store from './core/store';
import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';

import { initSentry } from './core/helpers/sentry.helper';
// import App.vue

const app = createApp(App);

initSentry(app, router);

app.use(VueFire, {
   // imported above but could also just be created here
   firebaseApp,
   modules: [
      // we will see other modules later on
      VueFireAuth(),
   ],
});
app.use(router);
app.use(store);

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isoWeek);

// directives
app.directive('outside-click', OutsideClickDirective);

// sentry
app.mount('#app');

export default app;
